// extracted by mini-css-extract-plugin
export default {"container":"chips-container_container__GjWwx","list_box":"chips-container_list_box__dxpM1","chip":"chips-container_chip__229Ub","reset_button":"chips-container_reset_button__4W7As"};